import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import { startUserSimulation, endUserSimulation, isSimulating } from "@culturehq/client";
import { Button, ModalDialog, Success } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "components/common/ChqModalDialog";

class SimulateContext extends Component {
  state = {
    open: false,
    simulating: false,
    success: false,
    error: false,
    loading: false
  };

  static getDerivedStateFromProps() {
    return { simulating: isSimulating() };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleClick = async () => {
    const { history, userId, refreshProfile } = this.props;
    const { simulating } = this.state;

    this.setState({
      success: false,
      error: false,
      loading: t("Loading...")
    });

    try {
      if (simulating) {
        await endUserSimulation();
      } else {
        await startUserSimulation({ userId });
      }

      refreshProfile();

      this.setState({ open: false, success: false, error: false, loading: false }, () => {
        history.push("/");
        window.location.reload();
      });
    } catch (error) {
      this.setState({
        success: false,
        error,
        loading: false
      });
    }
  };

  render() {
    const { userId, name, email, children } = this.props;
    const { open, success, error, loading, simulating } = this.state;

    const action = simulating ? t("End Simulation") : t("Start Simulation");

    return (
      <>
        {children(this.handleOpen)}
        {open && (
          <ChqModalDialog onClose={this.handleClose}>
            <ModalDialog.Heading onClose={this.handleClose}>
              <Trans>Simulate a User</Trans>
            </ModalDialog.Heading>
            <ModalDialog.Body>
              {simulating && (
                <p className="form-description">
                  <Trans>You are currently simulating a user.</Trans>
                </p>
              )}

              {!simulating && (
                <>
                  <p className="form-description">
                    <Trans>
                      Would you like to simulate this user&#39;s experience? You
                      will be signed in as their account and take actions on
                      their behalf.
                    </Trans>
                  </p>
                  <br />
                  <p>
                    <strong>User ID:</strong> {userId}
                  </p>
                  <p>
                    <strong>Name:</strong> {name}
                  </p>
                  <p>
                    <strong>E-Mail:</strong> {email}
                  </p>
                </>
              )}

              <br />

              {error && <ErrorMessage error={error} />}

              {success && (
                <Success><Trans>Success!</Trans></Success>
              )}

              {!success && (
                <Button primary className="sim--action" onClick={this.handleClick}>
                  {loading || action}
                </Button>
              )}
            </ModalDialog.Body>
          </ChqModalDialog>
        )}
      </>
    );
  }
}

const Simulate = props => {
  const history = useHistory();
  const { refreshProfile } = useProfile();

  return <SimulateContext {...props} history={history} refreshProfile={refreshProfile} />;
};

export default Simulate;
